// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from 'dayjs'
import { ReturnIcon } from '../../assets/icons/Return'
import { ContainerTitle } from '../../components/TitlePage/TitlePage'
import { Loading } from '../../components/Loading/Loading'
import { whatsappMask } from '../../utils/masks'
import { useMensagensEnviadasDetalhe } from './useMensagensEnviadasDetalhe'
import {
  ConteudoFrame,
  ConteudoLabel,
  ConteudoTexto,
  Container,
  DivTop,
  ErroBox,
  InfoGrid,
  InfoItem,
  Painel,
  Span,
} from './MensagensEnviadasDetalhe.style'

function canalLabel(canal: string): string {
  return canal === 'EMAIL' ? 'E-mail' : 'WhatsApp'
}

function statusLabel(status: string): string {
  return status === 'ENVIADO' ? 'Enviado' : 'Falha'
}

// Sem número = mensagem enviada antes de o sistema registrar o remetente (não há como reconstruir).
function remetenteLabel(detalhe: GetMensagemEnviadaDetalheType): string {
  if (!detalhe.remetenteNumero) {
    return 'não registrado'
  }
  const numero = whatsappMask(detalhe.remetenteNumero)
  if (detalhe.remetenteOrigem === 'PESSOAL') {
    return `${numero} (WhatsApp pessoal)`
  }
  if (detalhe.remetenteOrigem === 'ORGANIZACAO') {
    return `${numero} (WhatsApp da organização)`
  }
  return numero
}

export function MensagensEnviadasDetalhe() {
  const { detalhe, isLoading, erro } = useMensagensEnviadasDetalhe()

  return (
    <Container>
      <ToastContainer theme="dark" />
      <ContainerTitle>
        <DivTop>
          <Link to="/historico-mensagens">
            <ReturnIcon />
          </Link>
          <Span>Detalhe da mensagem</Span>
        </DivTop>
      </ContainerTitle>

      {isLoading && <Loading contrast />}

      {!isLoading && erro && <Painel>Mensagem não encontrada.</Painel>}

      {!isLoading && !erro && detalhe && (
        <Painel>
          <InfoGrid>
            <InfoItem>
              <span>Canal</span>
              <span>{canalLabel(detalhe.canal)}</span>
            </InfoItem>
            <InfoItem>
              <span>Status</span>
              <span>{statusLabel(detalhe.status)}</span>
            </InfoItem>
            <InfoItem>
              <span>Destinatário</span>
              <span>{detalhe.destinatario}</span>
            </InfoItem>
            {detalhe.canal === 'WHATSAPP' && (
              <InfoItem>
                <span>Remetente</span>
                <span>{remetenteLabel(detalhe)}</span>
              </InfoItem>
            )}
            <InfoItem>
              <span>Cliente</span>
              <span>{detalhe.clienteNome || '-'}</span>
            </InfoItem>
            <InfoItem>
              <span>Enviado por</span>
              <span>{detalhe.usuarioEmail || '-'}</span>
            </InfoItem>
            <InfoItem>
              <span>Data/hora</span>
              <span>{dayjs(detalhe.dataHora).format('DD/MM/YYYY HH:mm')}</span>
            </InfoItem>
            {detalhe.assunto && (
              <InfoItem>
                <span>Assunto</span>
                <span>{detalhe.assunto}</span>
              </InfoItem>
            )}
            {detalhe.status === 'ENVIADO' && detalhe.canal === 'EMAIL' && (
              <InfoItem>
                <span>Aberto em</span>
                <span>
                  {detalhe.dataAbertura
                    ? dayjs(detalhe.dataAbertura).format('DD/MM/YYYY HH:mm')
                    : 'Não aberto'}
                </span>
              </InfoItem>
            )}
            {detalhe.status === 'ENVIADO' && detalhe.canal === 'WHATSAPP' && (
              <InfoItem>
                <span>Entregue em</span>
                <span>
                  {detalhe.dataEntrega
                    ? dayjs(detalhe.dataEntrega).format('DD/MM/YYYY HH:mm')
                    : 'Não confirmado'}
                </span>
              </InfoItem>
            )}
            {detalhe.status === 'ENVIADO' && detalhe.canal === 'WHATSAPP' && (
              <InfoItem>
                <span>Lido em</span>
                <span>
                  {detalhe.dataLeitura
                    ? dayjs(detalhe.dataLeitura).format('DD/MM/YYYY HH:mm')
                    : 'Não confirmado'}
                </span>
              </InfoItem>
            )}
          </InfoGrid>

          <ConteudoLabel>Conteúdo</ConteudoLabel>
          {detalhe.canal === 'EMAIL' ? (
            <ConteudoFrame
              title="Conteúdo do e-mail"
              sandbox=""
              srcDoc={detalhe.conteudo || ''}
            />
          ) : (
            <ConteudoTexto>{detalhe.conteudo || '-'}</ConteudoTexto>
          )}

          {detalhe.status === 'FALHA' && detalhe.erro && (
            <ErroBox>Erro no envio: {detalhe.erro}</ErroBox>
          )}
        </Painel>
      )}
    </Container>
  )
}
